import React from "react";
import _ from "lodash";
import { Table, Image } from "semantic-ui-react";
import ssn from "../../assets/images/ssn.png";

export default function deceasesedRecord(props) {
  if (props.result === undefined) {
    return null;
  }
  const deceasedNode = _.get(props.result, "deceased[0]");
  let dob = "Unavailable";
  if (props.userAccount.btType === "1" || props.userAccount.btType === "2") {
    dob = _.get(deceasedNode, "dob[0]", "");
  }
  let dod = "Unavailable";
  if (props.userAccount.btType === "1" || props.userAccount.btType === "2") {
    dod = _.get(deceasedNode, "dod[0]._", "");
  }
  return (
    <Table key={`res_ssn_ver_des_${props.index}`}>
      <Table.Body>
        <Table.Row>
          <Table.Cell rowSpan={4}>
            <Image src={ssn} />
          </Table.Cell>
          <Table.Cell>Name:</Table.Cell>
          <Table.Cell>{`${_.get(deceasedNode, "firstName[0]._", "")} ${_.get(
            deceasedNode,
            "lastName[0]._",
            ""
          )} ${_.get(props.result, "lastState[0]._", "")}`}</Table.Cell>
          <Table.Cell>SSN:</Table.Cell>
          <Table.Cell>{_.get(deceasedNode, "ssn[0]._", "")}</Table.Cell>
          <Table.Cell>Status:</Table.Cell>
          <Table.Cell>{_.get(deceasedNode, "status[0]._", "")}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Date Of Birth:</Table.Cell>
          <Table.Cell>{dob}</Table.Cell>
          <Table.Cell>Date Of Deceased:</Table.Cell>
          <Table.Cell colSpan={3}>{dod}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Last Location:</Table.Cell>
          <Table.Cell colSpan={5}>
            {`${_.get(deceasedNode, "lastCity[0]._", "")} ${_.get(
              deceasedNode,
              "lastState[0]._",
              ""
            )} ${_.get(deceasedNode, "lastZip[0]._", "")}`}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}



// WEBPACK FOOTER //
// ./src/components/searchresults/DeceasedRecord.js